import * as yup from 'yup'

import i18 from '../i18n'

export const SignupSchema = () =>
  yup.object().shape({
    number: yup.string().required(i18.t('loginPg.continueCheck.err1')).max(1000000000, i18.t('loginPg.number.err1')),
    code: yup.string().required(i18.t('loginPg.continueCheck.err2')),
  })
